module.exports = __webpack_public_path__ + "img/credential-text-digital-marketing.d236847003df408d2d00fc30bb76e465.svg";